export enum LiquiditySource {
  SUSHISWAP = 'Sushiswap',
  V2 = 'V2',
  V3 = 'V3',
}

export enum FeePoolSelectAction {
  MANUAL = 'Manual',
  RECOMMENDED = 'Recommended',
}
